import { Tooltip } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

type TipProps = {
  titleLocale: string;
  longText?: boolean;
  children?: React.ReactNode;
};

export default function Tip({ titleLocale, longText = false, children }: TipProps) {
  const { t } = useLocales();

  return (
    <Tooltip
      title={<>{t(titleLocale)}</>}
      slotProps={
        longText
          ? { tooltip: { sx: { fontSize: 13, lineHeight: 1.6, maxWidth: 340, p: 1.5 } } }
          : undefined
      }
    >
      <span>{children}</span>
    </Tooltip>
  );
}
